import { createSlice } from '@reduxjs/toolkit';

const coreSlice = createSlice({
  name: 'core',
  initialState: {
    isTma: false,
    siteImageConfig: {},
    knowledgeCategory: [],
    applicationCategory: [],
    categoryImages: {},
  },

  reducers: {
    setIsTma: (state, action) => {
      state.isTma = action.payload;
    },
    setSiteImageConfig: (state, action) => {
      state.siteImageConfig = action.payload;
    },
    setKnowledgeCategory: (state, action) => {
      state.knowledgeCategory = action.payload;
    },
    setApplicationCategory: (state, action) => {
      state.applicationCategory = action.payload;
    },
    setCategoryImages: (state, action) => {
      state.categoryImages = action.payload;
    },
  },
});

export const { setIsTma, setSiteImageConfig, setKnowledgeCategory, setApplicationCategory, setCategoryImages } =
  coreSlice.actions;

export const coreReduce = coreSlice.reducer;
export default coreSlice.reducer;
